import SubViewOptions from '../SubViewOptions';
import React from 'react';
import {GeofenceApp} from "./Functionality/GeofenceApp";
import GeofenceMap from "./GeofenceMap";
import CustomSearch from "../../../../../../components/SearchSimples/CustomSearch";

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param string - subView: sub-view type
 * @param event - changeSubViewManage: event to change the sub-view
 */
const Geofence = (
    {
        option,
        subView,
        searchElement,
        registerAction,
        setSimpleSearch,
        selectForDelete,
        setSearchElement,
        setSelectForDelete,
        changeSubViewManage
    }
) => {

    const {
        t,
        DEV,
        goUrl,
        center,
        dayArray,
        expanded,
        selected,
        geofences,
        direction,
        permission,
        setSelected,
        setExpanded,
        setGeofences,
        handleMapMove,
        deleteModalShow,
        getActionsButtons,
        handleUpdateStatus,
        setDeleteModalShow,
        handleDeleteSelected,
        showActiveInactiveModal,
        setShowActiveInactiveModal,
        handleUpdateHierarchyLevel,
    } = GeofenceApp({
        option,
        subView,
        searchElement,
        registerAction,
        setSimpleSearch,
        selectForDelete,
        setSearchElement,
        setSelectForDelete,
        changeSubViewManage
    })


    return (
        <>
            <div className="d-flex input-padding-bottom">
                <SubViewOptions
                    subView={subView}
                    changeSubViewManage={changeSubViewManage}
                />
                <div className='w-100 ml-3'>
                    <CustomSearch
                        id={"txt_g_search_geofence"}
                        label={'type_something_to_search'}
                        value={searchElement}
                        setValue={setSearchElement}
                        onChange={(e) => setSearchElement(e.target.value)}
                        onReset={() => setSearchElement("")}
                    />
                </div>
            </div>
            <GeofenceMap
                t={t}
                DEV={DEV}
                goUrl={goUrl}
                center={center}
                expanded={expanded}
                selected={selected}
                dayArray={dayArray}
                geofences={geofences}
                direction={direction}
                permission={permission}
                setExpanded={setExpanded}
                setSelected={setSelected}
                setGeofences={setGeofences}
                handleMapMove={handleMapMove}
                deleteModalShow={deleteModalShow}
                getActionsButtons={getActionsButtons}
                setDeleteModalShow={setDeleteModalShow}
                handleUpdateStatus={handleUpdateStatus}
                handleDeleteSelected={handleDeleteSelected}
                showActiveInactiveModal={showActiveInactiveModal}
                setShowActiveInactiveModal={setShowActiveInactiveModal}
                handleUpdateHierarchyLevel={handleUpdateHierarchyLevel}
            />
        </>
    );
}

export default Geofence
